import Mac from "../Images/PC-MAC.png";
import Crispy from "../Images/PC-Crispy.png";
import PDF from "../Images/PC-PDF.png";
import Jemla from "../Images/PC-Jemla.png";
import Storycess from "../Images/Storycess.png";
import UIPLATE from "../Images/PC-UIPLATE.png";
import Color from "../Images/PC-Color.png";
import Needder from "../Images/PC-Needder.png";
import { iconStyle } from "../../components/Showcase/Showcase";
import { FaGithub } from "react-icons/fa";

export const projects = [
    {
        image: Needder,
        title: "Needder",
        description:
            "Needder.com is a jobbing platform: it's main concept is to connect the client (The person who needs a hand for services) and the freelancer (A person or company with the skills and time available) safely.",
        preview: "https://www.needder.com/",
        secondBtn: "Preview",
        tags: [
            { label: "React" },
            { label: "Typescript", bgColor: "#2F74C0" },
            { label: "Node.js", bgColor: "#6CA368" },
            {
                label: "Recoil",
                bgColor: "rgb(118, 74, 188)",
            },
            {
                label: "TailwindCSS",
                bgColor: "#39BDF9",
            },
        ],
    },
    {
        image: UIPLATE,
        title: "UI Plate",
        description:
            "UI Plate is a digital marketplace with a growing library of high quality website templates & UX/UI design resources",
        preview: "https://www.uiplate.com/",
        secondBtn: "Preview",
        tags: [
            { label: "React" },
            { label: "Typescript", bgColor: "#2F74C0" },
            { label: "Node.js", bgColor: "#6CA368" },
            { label: "Express.js", bgColor: "#111" },
            { label: "Firebase", bgColor: "#F2C12C" },
            {
                label: "Recoil",
                bgColor: "rgb(118, 74, 188)",
            },
            {
                label: "TailwindCSS",
                bgColor: "#39BDF9",
            },
            {
                label: "GraphQL",
                bgColor: "#E10096",
            },
        ],
    },
    {
        image: Storycess,
        title: "Storycess",
        description:
            "Storycess is a blog specialized in posting successful people's & company's stories",
        preview: "https://www.storycess.com/",
        secondBtn: "Preview",
        tags: [
            { label: "React" },
            { label: "Next.js", bgColor: "#111" },
            {
                label: "Recoil",
                bgColor: "rgb(118, 74, 188)",
            },
            {
                label: "TailwindCSS",
                bgColor: "#39BDF9",
            },
            {
                label: "GraphQL",
                bgColor: "#E10096",
            },
        ],
    },
    {
        image: Jemla,
        title: "Jemla shop",
        description:
            "Jemla is an online B2B wholesale market for suppliers to find and work together in order to facilitate their buy/sell operations",
        preview: "https://jemla-developement.web.app/",
        secondBtn: "Preview",
        tags: [
            { label: "React" },
            {
                label: "Redux",
                bgColor: "rgb(118, 74, 188)",
            },
            {
                label: "Wholesale",
                bgColor: "#e63939",
            },
            {
                label: "Firebase",
                bgColor: "#F2C12C",
            },
        ],
    },
    {
        image: PDF,
        title: "File management system for teachers",
        description:
            "A system destined for teachers to manage and archive their documents for their students ",
        preview: "https://pdf-manager-e8d02.web.app/",
        secondBtn: "Preview",
        tags: [
            { label: "React" },
            {
                label: "Management",
                bgColor: "#e63939",
            },
            {
                label: "Redux",
                bgColor: "rgb(118, 74, 188)",
            },
            {
                label: "Firebase",
                bgColor: "#F2C12C",
            },
        ],
    },
    {
        image: Crispy,
        title: "Crispy Chicken",
        description:
            "Crispy Chicken is a restaurant website I designed & developed for a fake company",
        code: "https://github.com/addayounes/CrispyChicken",
        preview: "https://addayounes.github.io/CrispyChicken/",
        firstBtn: "Code",
        secondBtn: "Preview",
        firstIcon: <FaGithub style={iconStyle} />,
        tags: [
            { label: "React" },
            {
                label: "Restaurant",
                bgColor: "#e63939",
            },
            {
                label: "Food",
                bgColor: "#d9c514",
            },
        ],
    },
    {
        image: Mac,
        title: "MAC Science Club",
        description: "MAC is a website I volunteered to design & develop for a science club.",
        code: "https://github.com/addayounes/MAC",
        preview: "https://www.mac-club-oran.com/",
        firstBtn: "Code",
        secondBtn: "Preview",
        firstIcon: <FaGithub style={iconStyle} />,
        tags: [
            { label: "React" },
            {
                label: "Science Club",
                bgColor: "#11ba7f",
            },
            {
                label: "Mechanics",
                bgColor: "#d9c514",
            },
        ],
    },
    {
        image: Color,
        title: "Color Recognition App",
        description: "An app that uses Clarifai's AI library to extract colors from an image",
        code: "https://github.com/addayounes/imageColorIdentifier",
        preview: "https://addayounes.github.io/imageColorIdentifier/",
        firstBtn: "Code",
        secondBtn: "Preview",
        firstIcon: <FaGithub style={iconStyle} />,
        tags: [
            { label: "React" },
            { label: "Styled-Components" },
            {
                label: "Ai",
                bgColor: "green",
            },
            {
                label: "Colors",
                bgColor: "#d91463",
            },
        ],
    },
];
